// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CvvPage{padding-bottom:10px}.CvvPage__cvvText{margin-top:8px;margin-bottom:8px;display:block}.CvvPage__cvvInput{height:32px !important;width:100% !important}.CvvPage__backButton{padding:unset !important;margin-top:12px;font-family:"UbuntuRegular";font-size:14px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
